import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {

  private platformSubject = new BehaviorSubject<string>(
    sessionStorage.getItem('platform') ?? 'Centrex Enreach'
  );

  public platform$ = this.platformSubject.asObservable();

  getCurrentPlatform(): string {
    return this.platformSubject.value;
  }

  setPlatform(platform: string): void {
    sessionStorage.setItem('platform', platform);
    this.platformSubject.next(platform);
  }
}